// The keyboard loop — the primary control surface.

import { goBack, pick } from "../core/navigation";
import { state } from "../core/state";
import { isAutopilotOn, stopAutopilot, toggleAutopilot } from "./autopilot";
import { closeDoc, synthesize } from "./docview";
import { $ } from "./dom";
import { closeGraph, isGraphOpen, openGraph } from "./graph";
import { runValidation } from "./validate";
import { closeWhatIf, whatIf } from "./whatif";

function onKey(e: KeyboardEvent): void {
  if (isGraphOpen()) {
    if (e.key === "Escape") closeGraph();
    return;
  }
  if ($("#wiOverlay").classList.contains("show")) {
    if (e.key === "Escape") closeWhatIf();
    return;
  }
  if ($("#docOverlay").classList.contains("show")) {
    if (e.key === "Escape") closeDoc();
    return;
  }
  // NEVER swallow keys while the user is typing anywhere (splash textarea,
  // inject input, future fields) — shortcuts only apply on the canvas.
  const t = e.target as HTMLElement | null;
  if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable)) return;
  if (e.ctrlKey || e.metaKey || e.altKey) return;   // leave browser chords alone

  if (e.key.toLowerCase() === "a") { e.preventDefault(); toggleAutopilot(); return; }
  if (isAutopilotOn()) stopAutopilot("autopilot off — you took the controls");

  if (e.key >= "1" && e.key <= "4") { e.preventDefault(); void pick(+e.key - 1); return; }
  if (e.key === "Tab") {   // Cursor-Tab style: accept the recommended default
    e.preventDefault();
    const n = state.nodes.get(state.currentId!);
    if (n && n.options.length) void pick(n.recommend ?? 0);
    return;
  }
  if (e.key === "ArrowLeft" || e.key === "Backspace") { e.preventDefault(); goBack(); return; }
  if (e.key === "/") { e.preventDefault(); (document.getElementById("injectInput") as HTMLInputElement | null)?.focus(); return; }
  if (e.key.toLowerCase() === "s") { e.preventDefault(); void synthesize(); return; }
  if (e.key.toLowerCase() === "v") { e.preventDefault(); void runValidation(); return; }
  if (e.key.toLowerCase() === "w") { e.preventDefault(); void whatIf(); return; }
  if (e.key === "Escape") { e.preventDefault(); openGraph(); return; }
}

export function initKeyboard(): void {
  document.addEventListener("keydown", onKey);
}
